/**
 * Ask ESPN for a logo the size we are actually going to draw it.
 *
 * Every crest in the app came straight from `/i/teamlogos/.../500/...`, which is
 * the full size original. The Raiders one is 572 KB. Drawn into a 28 pixel box in
 * a game card, or into the banner at 25% opacity as texture, that is 572 KB spent
 * on something nobody can see the detail of.
 *
 * It was also measurable: Cloudflare put Largest Contentful Paint at a P75 of 8.1
 * seconds and a P90 of 10, and named the decorative banner crest as the element.
 * A home page pulls about 30 logos at once, so the originals were megabytes of
 * PNG fighting over six connections.
 *
 * ESPN runs a resizer on the same host. Passing the same image through it at the
 * size we need takes the Raiders from 572 KB to 12 KB, and Cleveland from 94 KB
 * to 3 KB in a card. Same host, so it reuses the connection we already preconnect.
 *
 * Anything that is not an ESPN URL is handed back untouched.
 */

const ESPN = /^https?:\/\/a\.espncdn\.com(\/i\/.+)$/i;

/**
 * @param url   the logo as the API gave it
 * @param css   the size in CSS pixels it will be drawn at
 */
export function logo(url: string | null | undefined, css: number): string | undefined {
  if (!url) return undefined;
  const m = ESPN.exec(url);
  if (!m) return url;
  // twice the CSS size so it stays sharp on a retina screen, capped because the
  // original is 500 and asking for more just returns the original
  const px = Math.min(500, Math.round(css * 2));
  return `https://a.espncdn.com/combiner/i?img=${m[1]}&w=${px}&h=${px}`;
}
